/**
 * The build identifier, as the app sees it (REPORT-SPEC §6).
 *
 * `__SITE_BUILD__` is a Vite `define` — a textual substitution performed at
 * build time, not a variable that exists anywhere at run time. `site/build/
 * site-build.ts` decides its value and documents why it is a git short SHA.
 *
 * This module exists so exactly one file mentions the magic name. A `define`
 * that stops being applied — a config edit, a consumer compiled outside Vite —
 * turns the identifier into a `ReferenceError` at the point of use, which for
 * this feature would mean the report dialog throwing while the page around it
 * looks fine. The guard below turns that into `unknown` instead: a report that
 * cannot be placed on a timeline is worth far more than no report at all, and
 * the operator sees an honest `unknown` rather than a plausible wrong build.
 *
 * ## Why grepping `site/dist` for the SHA finds nothing
 *
 * Because nothing imports this yet, and Rollup drops what nothing imports. The
 * same will be true while the report feature sits behind a build-time flag that
 * is off — a disabled feature contributing no bytes is the flag working. The
 * substitution itself is proved by `site/test/site-build.test.ts`, which runs
 * through the same config; the bundle only carries the value once a shipped
 * code path reads it.
 */

declare const __SITE_BUILD__: string | undefined;

export const SITE_BUILD: string =
  typeof __SITE_BUILD__ === "string" && __SITE_BUILD__ !== ""
    ? __SITE_BUILD__
    : "unknown";
